/* KIRA - shared header: hamburger, Story dropdown keyboard support, cart mirror.
   Runs on every template. Independent of kira-hero.js. */
(function () {
  "use strict";

  var burger = document.getElementById("KiraBurger");
  var panel = document.getElementById("KiraPanel");
  var root = document.documentElement;

  /* ---- hamburger ---- */
  function setMenu(open) {
    if (!burger || !panel) return;
    burger.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      panel.setAttribute("data-open", "1");
    } else {
      panel.removeAttribute("data-open");
    }
    root.style.overflow = open ? "hidden" : "";
  }

  if (burger && panel) {
    burger.addEventListener("click", function () {
      setMenu(burger.getAttribute("aria-expanded") !== "true");
    });
    panel.addEventListener("click", function (e) {
      if (e.target === panel) setMenu(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && burger.getAttribute("aria-expanded") === "true") {
        setMenu(false);
        burger.focus();
      }
    });
    /* the burger and the inline nav swap at 760px - a panel left open above that
       breakpoint would cover the desktop layout */
    var wide = window.matchMedia("(min-width: 761px)");
    var onWide = function (e) {
      if (e.matches && burger.getAttribute("aria-expanded") === "true") setMenu(false);
    };
    if (wide.addEventListener) { wide.addEventListener("change", onWide); }
    else if (wide.addListener) { wide.addListener(onWide); }
  }

  /* ---- Story dropdown: keyboard parity with the CSS hover ---- */
  var storyBtn = document.querySelector(".kira-hdr__story-btn");
  if (storyBtn) {
    storyBtn.addEventListener("click", function () {
      var open = storyBtn.getAttribute("aria-expanded") === "true";
      storyBtn.setAttribute("aria-expanded", open ? "false" : "true");
    });
  }

  /* ---- cart count ----
     The theme's ajaxify drawer updates #cartCount, which lives in the old
     (hidden) header. Mirror it so this header stays truthful after an ajax add
     without stealing that id. */
  var source = document.getElementById("cartCount");
  var targets = document.querySelectorAll(".kira-hdr__count");
  if (source && targets.length && "MutationObserver" in window) {
    var sync = function () {
      var n = (source.textContent || "").replace(/[^\d]/g, "");
      if (n === "") return;
      for (var i = 0; i < targets.length; i++) targets[i].textContent = n;
    };
    new MutationObserver(sync).observe(source, {
      childList: true, characterData: true, subtree: true
    });
    sync();
  }
})();
